import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ variant }) => ({
  height: 45,
  ...(variant === "green" && {
    backgroundColor: "#4caf50 !important",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#388e3c !important",
    },
    "&.Mui-disabled": {
      cursor: "not-allowed",
      color: "#fff",
      backgroundColor: "#4caf50",
      opacity: 0.6,
    },
  }),
  ...(variant === "white" && {
    backgroundColor: "#ffffff !important",
    color: "#000",
    border: "1px solid #ccc",
    "&:hover": {
      backgroundColor: "#f0f0f0 !important",
    },
    "&.Mui-disabled": {
      cursor: "not-allowed",
      color: "#fff",
      backgroundColor: "#ccc",
      borderColor: "#ccc",
      opacity: 0.6,
    },
  }),
}));

const ButtonMain = ({ variant = "green", children, ...props }) => {
  return (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};

export default ButtonMain;
